import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  SanitizeService,
  SaveChangesModalService,
} from '@g99-product-web-ui/shared-service';
import { TickIcon } from '@g99-product-web-ui/shared-util-lib';
@Component({
  selector: 'lib-save-changes-modal',
  templateUrl: './save-changes-modal.component.html',
  styleUrl: './save-changes-modal.component.scss',
  standalone: false,
})
export class SaveChangesModalComponent {
  @Input() public isOpen = false; // Control modal visibility
  @Output() public changesSaved = new EventEmitter<void>();
  @Output() public changesDiscarded = new EventEmitter<void>();
  @Output() public closeModal = new EventEmitter<void>();
  public saveIcon = TickIcon;

  constructor(
    private readonly _modalService: SaveChangesModalService,
    private readonly _sanitizer: SanitizeService
  ) {}

  public saveChanges() {
    this.changesSaved.emit(); // Emit saved changes event
    this._modalService.respond(false); // Notify guard that changes are saved
    this.close();
  }

  public discardChanges() {
    this.changesDiscarded.emit(); // Emit discarded changes event
    this._modalService.respond(true); // Notify guard that changes are discarded
    this.close();
  }

  public close() {
    this.closeModal.emit(); // Notify parent to close the modal
    this.isOpen = false; // Close the modal
  }
  public get trustedSaveIcon() {
    return this._sanitizer.sanitizeContent(this.saveIcon);
  }
}
